import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as regularIcons from '@fortawesome/free-regular-svg-icons'
import { IconPack, IconDefinition, ExportArgs, svgStringToPng } from './types'

const fontAwesomeRegularPack: IconPack = {
  name: 'Font Awesome Regular',
  icons: Object.entries(regularIcons)
    .filter(([key]) => key.startsWith('fa'))
    .map(([key, value]) => ({
      name: key,
      icon: value,
      pack: 'font-awesome-regular',
    })),
  getIconComponent: (
    icon: IconDefinition,
    size?: number,
    color?: string,
    rotate?: number
  ) => (
    <FontAwesomeIcon
      icon={icon.icon}
      style={{
        fontSize: size ? `${size}px` : '24px',
        color: color || 'currentColor',
        transform: rotate ? `rotate(${rotate}deg)` : undefined,
      }}
    />
  ),
  exportSVG: ({ icon, logo }: ExportArgs) => {
    if (!icon.icon.icon) return undefined
    const [iconWidth, iconHeight, , , pathData] = icon.icon.icon
    const radius = logo.borderRadius || 0
    const borderWidth = logo.borderWidth || 0
    const iconBorderWidth = logo.iconBorderWidth || 0
    const rotation = logo.rotate || 0
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="256" height="256" viewBox="0 0 256 256">
        <rect
          x="${borderWidth / 2}" y="${borderWidth / 2}"
          width="${256 - borderWidth}" height="${256 - borderWidth}"
          rx="${radius}" ry="${radius}"
          fill="${logo.backgroundColor || '#ffffff'}"
          stroke="${logo.iconColor || '#000000'}"
          stroke-width="${borderWidth}"
        />
        <g transform="translate(128,128) rotate(${rotation}) scale(${
          logo.exactIconSize / iconHeight
        }) translate(-${iconWidth / 2},-${iconHeight / 2})">
          <path
            d="${pathData}"
            fill="${logo.iconColor || '#000000'}"
            stroke="${logo.iconColor || '#000000'}"
            stroke-width="${iconBorderWidth / (logo.exactIconSize / 256)}"
          />
        </g>
      </svg>
    `
  },
  exportPNG: async ({ icon, logo }: ExportArgs) => {
    const svg = fontAwesomeRegularPack.exportSVG?.({ icon, logo })
    if (!svg) return undefined
    return await svgStringToPng(svg)
  },
}

export default fontAwesomeRegularPack
